import Main from './main';
import Edit from './edit';
import Single from './single';
import AssetView from './asset-view';
import LogsPages from './logs';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/asset-view',
    Component: AssetView,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/logs',
    Component: LogsPages,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
